import { IonApp } from '@ionic/react';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { AppShell } from './components/AppShell';

const AccessPage = lazy(() => import('./pages/AccessPage').then((module) => ({ default: module.AccessPage })));
const AlertsPage = lazy(() => import('./pages/AlertsPage').then((module) => ({ default: module.AlertsPage })));
const CommunitiesPage = lazy(() => import('./pages/CommunitiesPage').then((module) => ({ default: module.CommunitiesPage })));
const FeedPage = lazy(() => import('./pages/FeedPage').then((module) => ({ default: module.FeedPage })));
const FamilyPage = lazy(() => import('./pages/FamilyPage').then((module) => ({ default: module.FamilyPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((module) => ({ default: module.ProfilePage })));
const SafetyPage = lazy(() => import('./pages/SafetyPage').then((module) => ({ default: module.SafetyPage })));
const OrganizationSetupPage = lazy(() => import('./pages/OrganizationSetupPage').then((module) => ({ default: module.OrganizationSetupPage })));
const PendingAccessPage = lazy(() => import('./pages/PendingAccessPage').then((module) => ({ default: module.PendingAccessPage })));

function LoadingScreen() {
  return <div className="app-loading" role="status">Verificando acceso…</div>;
}

function AccessEntry() {
  const { status } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'active' || status === 'demo') return <Navigate to="/inicio" replace />;
  if (status === 'needs-bootstrap') return <Navigate to="/configurar-institucion" replace />;
  if (status === 'pending') return <Navigate to="/espera" replace />;
  return <AccessPage />;
}

function ProtectedShell() {
  const { status, error } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'signed-out') return <Navigate to="/acceso" replace />;
  if (status === 'needs-bootstrap') return <Navigate to="/configurar-institucion" replace />;
  if (status === 'pending') return <Navigate to="/espera" replace />;
  if (status === 'error') return <div className="app-loading" role="alert">No pudimos verificar el acceso. {error}</div>;
  return <AppShell />;
}

function SetupEntry() {
  const { status } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'signed-out') return <Navigate to="/acceso" replace />;
  if (status === 'active' || status === 'demo') return <Navigate to="/inicio" replace />;
  if (status === 'pending') return <Navigate to="/espera" replace />;
  return <OrganizationSetupPage />;
}

function PendingEntry() {
  const { status } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'signed-out') return <Navigate to="/acceso" replace />;
  if (status === 'active' || status === 'demo') return <Navigate to="/inicio" replace />;
  if (status === 'needs-bootstrap') return <Navigate to="/configurar-institucion" replace />;
  return <PendingAccessPage />;
}

export default function App() {
  return (
    <IonApp>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="app-loading" role="status">Cargando comunidad…</div>}>
            <Routes>
              <Route path="/acceso" element={<AccessEntry />} />
              <Route path="/configurar-institucion" element={<SetupEntry />} />
              <Route path="/espera" element={<PendingEntry />} />
              <Route element={<ProtectedShell />}>
                <Route path="/inicio" element={<FeedPage />} />
                <Route path="/comunidades" element={<CommunitiesPage />} />
                <Route path="/avisos" element={<AlertsPage />} />
                <Route path="/perfil" element={<ProfilePage />} />
                <Route path="/familia" element={<FamilyPage />} />
                <Route path="/seguridad" element={<SafetyPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/inicio" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </IonApp>
  );
}
